module.exports = fox._r("images/press/materials-icon-lg.png", __webpack_public_path__ + "_/common/images/press/materials-icon-lg.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/press/materials-icon-lg.png
// module id = 368
// module chunks = 2